(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("nullPropagation", [], factory);
	else if(typeof exports === 'object')
		exports["nullPropagation"] = factory();
	else
		root["nullPropagation"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition